module.exports = __webpack_public_path__ + "img/paysafecard-paysafecash-phone.4f7efb70.png";